<template>
  <div class="main">
    <Header :title="title" />
    <div class="container my-con">
      <div class="card">
        <h2 class="title">
          {{ title }}
        </h2>
        <base-info :base-info="reportInfo" />
        <item-detail title-text="报告附件">
          <template>
            <div class="content">
              <van-swipe>
                <van-swipe-item
                  v-for="(item, index) in this.picUrls"
                  :key="index"
                >
                  <van-image
                    :src="$imgUrl + item.url"
                    @click="seeImg($imgUrl + item.url)"
                    alt=""
                  />
                </van-swipe-item>
              </van-swipe>
            </div>
          </template>
        </item-detail>

        <item-detail title-text="诊断结果">
          <template>
            <div class="content">
              {{ pathologicalCervixRes }}
            </div>
          </template>
        </item-detail>
        <item-detail title-text="">
          <template>
            <div class="doctor-message">
              <div>检查医院：{{ reportInfo.pathologicalCervixHospitalName }}</div>
              <div>检查医师：{{ reportInfo.pathologicalCervixDoctor }}</div>
            </div>
          </template>
        </item-detail>
      </div>
      <div class="card">
        <van-cell
          title="用户资料"
          is-link
          @click="viewUserData"
        />
      </div>
      <van-overlay :show="loading">
        <div class="loading-box">
          <van-loading>加载中...</van-loading>
        </div>
      </van-overlay>
    </div>
  </div>
</template>

<script>
import Header from '@/components/header'
import baseInfo from '@/components/baseInfo'
import itemDetail from '@/components/ItemDetail'
import { Cell, Image, ImagePreview, Loading, Overlay, Swipe, SwipeItem } from 'vant'
import { deepJsonParse } from '@/utils/handleJSON'
import { formatPathologicalCervixResult } from '@/utils/pathologicalCervix'

export default {
  components: {
    Header,
    baseInfo,
    itemDetail,
    [Cell.name]: Cell,
    [Image.name]: Image,
    [Loading.name]: Loading,
    [Overlay.name]: Overlay,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem
  },
  data () {
    return {
      title: '病理检查报告',
      reportInfo: {
        name: '',
        sex: '',
        age: '',
        date: '',
        id: ''
      },
      pathologicalCervix: {},
      picUrls: [],
      loading: false
    }
  },
  computed: {
    pathologicalCervixRes () {
      return formatPathologicalCervixResult(
        this.pathologicalCervix,
        this.reportInfo.fertileCheck
      )
    }
  },
  created () {
    this.getData()
  },
  methods: {
    async getData () {
      this.loading = true
      // 获取报告详情
      const { data } = await this.$api.personal.getReportDetail({
        id: this.$route.params.id
      })
      const { data: ins } = await this.$api.personal.getInstitutionById({
        id: data.institutionId
      })
      this.loading = false
      const { pathologicalCervixDate, pathologicalCervix, ...detail } = data
      this.pathologicalCervix = deepJsonParse(pathologicalCervix)
      // 过滤得到宫颈病理图片
      this.picUrls = data.pictures.filter(item => item.picType === 14).map(item => {
        return {
          url: item.picUrl,
          position: item.position
        }
      })
      detail.date = pathologicalCervixDate
      detail.fertileCheck = ins.fertileCheck
      this.reportInfo = detail
    },
    viewUserData () {
      this.$router.push(`/jcbg/${this.reportInfo.id}`)
    },
    seeImg (url) {
      ImagePreview({
        images: [url],
        showIndex: false
      })
    }
  }
}
</script>

<style scoped lang="less">
.container {
  font-size: 0.32rem;
  background-color: #f7f7f7;
  .card {
    background-color: white;
    margin-bottom: .2rem;
  }
  h2 {
    padding: 15px 0;
    font-size: 0.44rem;
    font-weight: 400;
    text-align: center;
  }
  .content {
    font-size: 0.28rem;
  }
  .doctor-message {
    font-size: .28rem;
    display: flex;
    justify-content: space-between;
  }
  .loading-box {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .van-loading__text{
      color: #ffffff;
    }
    .van-loading {
      color: #ffffff;
    }
  }
}

</style>
